import { useEffect } from "react";

export const useTitle = (title) => {
  useEffect(() => {
    const defaultTitle = "ClinicChat";
    document.title = title ? title + " | " + defaultTitle : defaultTitle;
  }, [title]);
};